import React, { useEffect, useState } from "react";
import "./InfluencerComp.scss";
import {
  formatNumberKMBT,
  ImgWithErrorHandling,
} from "pages/influencers/InfluencerCard";

interface InfluencerCompBoxProps {
  title: React.ReactNode;
  color: string;
  borderColor: string;
  available: number | string;
  influencers: any[];
  extraTag?: React.ReactNode;
  range?: string;
  disabled?: boolean;
}

const InfluencerCompBox: React.FC<InfluencerCompBoxProps> = ({
  title,
  color,
  borderColor,
  available,
  influencers,
  extraTag,
  range,
  disabled = false,
}) => {
  const [visibleCount, setVisibleCount] = useState(3);
  const visibleInfluencers = influencers?.slice(0, visibleCount) || [];
  const hasMore = influencers && visibleCount < influencers.length;

  useEffect(() => {
    setVisibleCount(3);
  }, [influencers]);

  // if (!influencers || influencers.length === 0) return null;

  return (
    <div
      className={`influencer-comp ${
        disabled ? "influencer-comp__disabled" : ""
      }`}
      style={{ border: `2px solid ${disabled ? "#e2e8f0" : borderColor}` }}
    >
      <div className="influencer-comp__header">
        <div
          className="influencer-comp__title"
          style={{ color: disabled ? "#a0aec0" : "#000" }}
        >
          {title}
        </div>
        <div className="influencer-comp__tags">
          <div
            className="influencer-comp__available"
            style={{ background: disabled ? "#e2e8f0" : color }}
          >
            {available} Available
          </div>
          {extraTag}
        </div>
      </div>
      {range && <div className="influencer-comp__range">{range}</div>}
      <div className="influencer-comp__list">
        {influencers.length > 0 ? (
          visibleInfluencers.map((inf: any, idx: number) => (
            <div
              key={idx}
              className={`influencer-comp__item ${
                disabled ? "influencer-comp__disabled" : ""
              }`}
            >
              <ImgWithErrorHandling
                src={inf.avatarUrl}
                alt={inf.mustardUserName}
                className="influencer-comp__avatar"
              />

              <div>
                <div
                  className="influencer-comp__name"
                  style={{
                    maxWidth: 120,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                  title={inf.mustardUserName}
                >
                  {inf.mustardUserName}
                </div>
                <div className="influencer-comp__meta">
                  {formatNumberKMBT(inf.socialMediaFollowers)} •{" "}
                  {inf?.engagementRate?.toFixed(2) || 1}% engagement
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="influencer-comp__no-data">
            No influencers available with the selected criteria.
          </div>
        )}
      </div>
      {hasMore && !disabled && (
        <div className="influencer-comp__loadmore">
          <button
            className="influencer-comp__loadmore-btn"
            onClick={() => setVisibleCount((prev) => prev + 3)}
            type="button"
            disabled={disabled}
          >
            + Load more examples
          </button>
        </div>
      )}
    </div>
  );
};

export default InfluencerCompBox;
